export default __webpack_public_path__ + "static/gmx-705554bdc9401b648fa121a9afa79629.jpg";